import { debounce } from "./modules/animation.js";

(function () {
  const html = document.documentElement;
  const body = document.body;
  const navbar = document.querySelector(NAVBAR);
  const menuIcon = navbar.querySelector(".js-menuIcon");
  const closeIcon = navbar.querySelector(".js-closeIcon");
  const sidebar = document.querySelector(".js-sidebar");
  const depicterOrCover = document.querySelector(".depicter, .ci-Cover:not(.is-fullScreen)");
  // const depicterOrCover = document.querySelector(".depicter, .ci-Cover:not(.is-fullScreen, .is-boxLeft)");
  const isReverseNavbar = body.classList.contains("is-reverseNavbar");
  let isSidebarOpen = false;
  let currentMenuItem = [];
  const navbarLinks = document.querySelectorAll(".js-navbar-link");
  const megaMenus = document.querySelectorAll(".js-megaMenu");
  const isfixedNavDark = navbar.classList.contains("js-fixedNav-darkMode");
  let currentColorTheme = "";
  const classNamesPages = ["page-magazine", "single-magazine"];
  const megaMenuMasks = document.querySelectorAll(".ci-MegaMenu-mask");

  /**
   * Checks if the current theme is dark by evaluating the presence of specific CSS class names in the document body.
   *
   * @returns {boolean} - `true` if the current theme is dark, otherwise `false`.
   */
  const checkDarkTheme = () => {
    if (document?.body && classNamesPages.some((className) => document.body.classList.contains(className))) {
      currentColorTheme = localStorage.getItem(COLOR_THEME) || COLOR_THEME_CURRENT;
      return currentColorTheme && currentColorTheme === THEME_DARK;
    }
    return false;
  };

  /**
   * Adjusts the margin top of an element based on the height of the WordPress admin bar.
   *
   * @param {HTMLElement} element - The element to adjust the margin top for.
   * @param {boolean} [negative=false] - Whether to adjust the margin top negatively or positively.
   *
   * @returns {string|null} - The adjusted margin top value or null if wpAdminBar is not available.
   */
  const adjustElementMarginTop = (element, negative = false) => {
    const wpAdminBar = document.getElementById("wpadminbar");

    if (!wpAdminBar) {
      return null;
    }

    const wpAdminBarHeight = wpAdminBar.offsetHeight;
    const elemMarginTop = negative ? "-" + wpAdminBarHeight + "px" : wpAdminBarHeight + "px";

    return (element.style.marginTop = elemMarginTop);
  };

  /**
   * Calculates the top padding of the main slider based on the window width.
   *
   * @param {number} windowWidth - The width of the window.
   * @returns {number} - The calculated top padding value.
   */
  const displayMainSliderPaddingTop = (windowWidth) => {
    if (!depicterOrCover) {
      return 0;
    }

    if (depicterOrCover) {
      if (windowWidth !== null) {
        let depicterOrCoverPaddingTopPx = window.getComputedStyle(depicterOrCover).paddingTop;

        return parseFloat(depicterOrCoverPaddingTopPx);
      }
    }
  };

  /**
   * Updates the color of navigation bar elements according to sidebar state,
   * scroll position and window width. scroll position and window width.
   *
   * @returns {void}
   */
  const updateNavbarItemsColor = () => {
    const scrollY = window.scrollY;
    const windowWidth = window.innerWidth;
    const isMegaMenuOpen = !!document.querySelector(".js-megaMenu.is-open");

    navbar.style.getPropertyValue("--menu-bgc");

    navbar.classList[!isMegaMenuOpen && checkDarkTheme() ? "add" : "remove"]("is-darkmode");

    const displayFixedNavbar = scrollY > displayMainSliderPaddingTop(windowWidth);
    if (displayFixedNavbar) {
      navbar.classList.add("ci-navbar-scrolling");
    } else {
      navbar.classList.remove("ci-navbar-scrolling");
    }

    return isfixedNavDark || isSidebarOpen || displayFixedNavbar
      ? setColor(isMegaMenuOpen)
      : setTransparent(isMegaMenuOpen, windowWidth);
  };

  updateNavbarItemsColor();

  window.addEventListener(
    "resize",
    debounce(function () {
      updateNavbarItemsColor();
    }),
  );

  window.addEventListener("scroll", function () {
    updateNavbarItemsColor();
  });

  /**
   * Sets the transparency of the navigation bar and adjusts its position to the width of the window.
   *
   * @param {boolean} isMegaMenuOpen - Boolean value indicating whether the mega-menu is open or not.
   * @param {number} windowWidth - Browser width.
   */
  function setTransparent(isMegaMenuOpen, windowWidth) {
    depicterOrCover ? adjustElementMarginTop(body, true) : adjustElementMarginTop(navbar);
    navbar.style.setProperty("--menu-bgc", COLOR_THEME_TRANSPARENT);
    const mainSliderPAddingTop = displayMainSliderPaddingTop(windowWidth);
    navbar.style.top = mainSliderPAddingTop + "px";

    if (megaMenuMasks && megaMenuMasks.length) {
      megaMenuMasks.forEach((megaMenuMask) => {
        megaMenuMask.style.setProperty("--mega-menu-mask-height", mainSliderPAddingTop + 2);
        megaMenuMask.style.height = mainSliderPAddingTop + 2;
      });
    }

    // Need to keep main submenus visible on mouse-over
    if (isMegaMenuOpen) {
      setColorWhiteAfterDelay();
    }
  }

  /**
   * Defines the color of the navigation bar according to the supplied setting
   *
   * @param {boolean} isMegaMenuOpen - Boolean value indicating whether the mega-menu is open or not.
   */
  function setColor(isMegaMenuOpen) {
    adjustElementMarginTop(navbar);

    const setPropertyValue = () => {
      if (isMegaMenuOpen) {
        // Need to have a correct opacity transition during animation
        return COLOR_THEME_TRANSPARENT;
      } else if (isfixedNavDark || checkDarkTheme()) {
        return COLOR_THEME_DARK;
      } else if (isReverseNavbar) {
        return COLOR_THEME_LIGHT;
      } else {
        // return COLOR_THEME_DARK;
        return COLOR_THEME_LIGHT; // default value
      }
    };
    navbar.style.setProperty("--menu-bgc", setPropertyValue());
    navbar.style.top = 0;
    navbar.style.position = "fixed";

    // Need to keep main submenus visible on mouse-over
    if (isMegaMenuOpen) {
      setColorWhiteAfterDelay();
    }
  }

  /**
   * Sets the color of the navbar to white after a specified delay.
   * @return {void}
   */
  function setColorWhiteAfterDelay() {
    setTimeout(() => {
      navbar.style.setProperty("--menu-bgc", "#fff");
    }, 500);
  }

  /**
   * Toggle the sidebar open or closed.
   *
   * @param {boolean} shouldOpen - A boolean value indicating whether the sidebar should be opened or closed.
   * @returns {void}
   */
  const toggleSidebar = (shouldOpen) => {
    isSidebarOpen = shouldOpen;
    handleSidebar(isSidebarOpen);
    updateNavbarItemsColor();
  };

  // opening the sidebar
  if (menuIcon) {
    menuIcon.addEventListener("click", function (e) {
      e.preventDefault();
      toggleSidebar(!isSidebarOpen);
    });
  }

  // closing the sidebar
  if (closeIcon) {
    closeIcon.addEventListener("click", function (e) {
      e.preventDefault();
      toggleSidebar(false);
    });
  }

  // Closes an open sidebar and updates the color of navigation items when a click event occurs outside
  // the sidebar or the menu icon
  document.addEventListener("click", function (event) {
    if (!isSidebarOpen) {
      return;
    }
    const isClickInside = sidebar.contains(event.target);
    const isClickedOnOpen = menuIcon.contains(event.target);
    if (!isClickInside && !isClickedOnOpen) {
      toggleSidebar(false);
    }
  });

  /**
   * Function to handle the sidebar opening and closing.
   *
   * @param {boolean} isOpen - Boolean value indicating if the sidebar should be open (true) or closed (false).
   */
  const handleSidebar = (isOpen) => {
    sidebar.style.height = `calc(100vh - ${navbar.offsetHeight}px`;
    if (isOpen) {
      closeIcon.classList.add("is-visible");
      sidebar.classList.add("is-open");
      navbar.classList.add("is-active");
      html.classList.add("no-scroll");
    } else {
      closeIcon.classList.remove("is-visible");
      sidebar.classList.remove("is-open");
      navbar.classList.remove("is-active");
      html.classList.remove("no-scroll");
    }
  };

  /**
   * Toggles the "is-reverseNavbar" class on the body element based on a condition
   *
   * @param {boolean} condition - The condition based on which to toggle the class.
   */
  function toggleReverseNavbar(condition) {
    if (isReverseNavbar) {
      return;
    }

    if (condition) {
      body.classList.add("is-reverseNavbar");
    } else if (!condition) {
      body.classList.remove("is-reverseNavbar");
    }
  }

  /**
   * Handles the click event for a mega menu link.
   *
   * @param {string} href - The href attribute of the clicked mega menu link.
   * @param {Event} event - The click event object.
   *
   * @return {undefined} - This method does not return any value.
   */
  function handleMegaLinkClick(href, event) {
    event.preventDefault();

    const megaMenuId = href.slice(1);
    const megaMenu = document.getElementById(megaMenuId);

    if (!megaMenu) {
      return;
    }

    const isMegaMenuOpen = megaMenu.classList.contains("is-open");
    toggleMegaMenu(isMegaMenuOpen, megaMenu, event.target);
    updateNavbarItemsColor();
  }

  /**
   * Toggles the display of a mega menu.
   *
   * @param {boolean} isOpen - Indicates whether the mega menu is currently open or closed.
   * @param {HTMLElement} menuElem - The DOM element that represents the mega menu.
   * @param {HTMLElement} triggerElem - The DOM element that triggers the display of the mega menu.
   */
  function toggleMegaMenu(isOpen, menuElem, triggerElem) {
    if (isOpen) {
      closeMegaMenu(menuElem, triggerElem);
    } else {
      openMegaMenu(menuElem, triggerElem);
    }
  }

  /**
   * Opens a mega menu on the webpage.
   *
   * @param {HTMLElement} menuElem - The menu element that will be opened.
   * @param {HTMLElement} triggerElem - The element that triggered the opening of the menu.
   *
   * @return {undefined}
   */
  function openMegaMenu(menuElem, triggerElem) {
    closeAllMegaMenus();
    deactivateNavbarLinks();

    adjustElementMarginTop(menuElem);
    menuElem.style.paddingTop = `${navbar.offsetHeight + navbar.offsetTop}px`;
    menuElem.classList.add("is-open");
    triggerElem.classList.add("is-open");

    toggleReverseNavbar(true);

    html.classList.add("no-scroll");

    if (currentMenuItem.length > 0) {
      currentMenuItem[0].classList.remove("current-menu-item");
    }
  }

  /**
   * Closes the mega menu by removing relevant classes from specified menu element.
   *
   * @param {HTMLElement} menuElem - The menu element to close.
   * @param {HTMLElement} triggerElem - The element that triggered the closing of the menu.
   */
  function closeMegaMenu(menuElem, triggerElem) {
    menuElem.classList.remove("is-open");
    triggerElem.classList.remove("is-open");
    toggleReverseNavbar(false);
    html.classList.remove("no-scroll");
    if (currentMenuItem.length > 0) {
      currentMenuItem[0].classList.add("current-menu-item");
    }
  }

  /**
   * Closes all mega menus.
   *
   * @return {void}
   */
  function closeAllMegaMenus() {
    megaMenus.forEach((menu) => {
      menu.classList.remove("is-open");
    });
  }

  /**
   * Deactivates all navbar links by removing the "is-open" class from them.
   * @return {void}
   */
  function deactivateNavbarLinks() {
    navbarLinks.forEach((navbarLink) => {
      navbarLink.classList.remove("is-open");
    });
  }

  navbarLinks.forEach((navbarLink) => {
    const parentNavbarLink = navbarLink.parentElement;
    if (parentNavbarLink.classList.contains("current-menu-item")) {
      currentMenuItem.push(parentNavbarLink);
    }

    const hrefAttribute = navbarLink.getAttribute("href");
    if (hrefAttribute.startsWith("#")) {
      navbarLink.addEventListener("click", (e) => {
        handleMegaLinkClick(hrefAttribute, e);
      });
    }
  });

  // dipecter - template : |<a href="#mega-menu-destination" class="js-navbar-link">Destinations</a>|
  const megaMenuOpener = document.querySelectorAll(
    ".depicter-section a[href] > .menu-destination, .depicter-overlay-layers a[href] > .menu-destination, .depicter-overlay-layers a[href] > .depicter-animation-wrap > .menu-destination",
  ); // .depicter-section .menu-destination
  if (megaMenuOpener) {
    megaMenuOpener.forEach((item) => {
      const parentItem = item.parentElement;
      if (parentItem && parentItem.tagName.toLowerCase() == "a") {
        const hrefAttribute = parentItem.getAttribute("href");
        if (hrefAttribute && hrefAttribute.startsWith("#")) {
          item.addEventListener("click", (e) => {
            handleMegaLinkClick(hrefAttribute, e);
          });
        }
      }
    });
  }

  /**
   * Update the image source and text content based on the specified element's dataset.
   *
   * @param {HTMLElement} element - The element to update.
   * @param {HTMLImageElement} image - The image element to update.
   * @param {HTMLElement} text - The text element to update.
   */
  const updateImageAndText = (element, image, text) => {
    if (element && image && "thumb" in element.dataset) {
      if (element.dataset.thumb !== "") {
        image.src = element.dataset.thumb;
        image.classList.remove("opacity-0");

        if (text) {
          text.textContent = element.textContent;
        }
      } else {
        // image.src = "/wp-content/themes/continents-insolites/dist/images/placeholder-revert.jpg";
        image.src = "";
        image.classList.add("opacity-0");
      }
    }
  };

  megaMenus.forEach((menu) => {
    const megaMenuLinks = menu.querySelectorAll(".js-megaMenu-link");
    const megaMenuImage = menu.querySelector(".js-megaMenu-img");
    const megaMenuText = menu.querySelector(".js-megaMenu-txt");
    const megaMenucloseIcon = menu.querySelector(".js-megaMenu-closeIcon");
    const collapseLinks = menu.querySelectorAll(".js-megaMenu-collapse");
    const collapsedLists = menu.querySelectorAll(".js-megaMenu-collapsed");

    // We have to hide the empty image by default, otherwise there's a border
    megaMenuImage.classList.add("opacity-0");

    window.addEventListener(
      "resize",
      debounce(function () {
        if (menu.classList.contains("is-open")) {
          adjustElementMarginTop(menu);
          menu.style.paddingTop = navbar.offsetHeight + navbar.offsetTop + "px";
        }
      }),
    );

    megaMenuLinks.forEach(function (element) {
      if (element) {
        if (element.classList.contains("is-active")) {
          updateImageAndText(element, megaMenuImage, megaMenuText);
        }

        element.addEventListener("mouseenter", function (event) {
          updateImageAndText(event.target, megaMenuImage, megaMenuText);
        });

        element.addEventListener(
          "touchstart",
          function (event) {
            updateImageAndText(event.currentTarget, megaMenuImage, megaMenuText);
          },
          { passive: true },
        );
      }
    });

    // closing the mega menu with close icon
    if (megaMenucloseIcon) {
      megaMenucloseIcon.addEventListener("click", function (e) {
        e.preventDefault();
        closeAllMegaMenus();
        deactivateNavbarLinks();
        toggleReverseNavbar(false);
        html.classList.remove("no-scroll");
        // Réinitialiser la classe ".current-menu-item" à l'élément correspondant lorsque le méga menu est fermé
        if (currentMenuItem.length > 0) {
          currentMenuItem[0].classList.add("current-menu-item");
        }
        updateNavbarItemsColor();
      });
    }

    collapseLinks.forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Reset all collapsed links and submenus
        collapseLinks.forEach((link) => link.classList.remove("is-active"));
        collapsedLists.forEach((list) => list.classList.remove("is-open"));

        // Add 'is-active' class to the clicked link
        elem.classList.add("is-active");

        // Make current sub list visible
        const subList = e.target.closest(".ci-MegaMenu-listItem").querySelector(".js-megaMenu-collapsed");
        if (subList) {
          subList.classList.add("is-open");
        }
      });
    });
  });

  // Determines if the "is-active" class is present in any of the elements with the class "js-megaMenu-link"
  // within the "mega-menu-envie" element
  const megaMenuEnvie = document.getElementById("mega-menu-envie");

  if (megaMenuEnvie) {
    const isActiveClassPresent = [...megaMenuEnvie.querySelectorAll(".js-megaMenu-link")].some((link) =>
      link.classList.contains("is-active"),
    );

    if (!isActiveClassPresent) {
      const firstCollapseElement = megaMenuEnvie.querySelector(".js-megaMenu-collapse");
      const firstCollapsedElement = megaMenuEnvie.querySelector(".js-megaMenu-collapsed");

      if (firstCollapseElement) {
        firstCollapseElement.classList.add("is-active");
      }

      if (firstCollapsedElement) {
        firstCollapsedElement.classList.add("is-open");
      }
    }
  }
})();
